import React from "react";
import { Route, Routes } from "react-router-dom";
import { AppProvider } from "./context/ThemeContext";
import AdminPage from "./pages/AdminPage";
import Blog from "./pages/Blog";
import ClientServicesAgreement from "./pages/ClientServicesAgreement";
import ContactUs from "./pages/ContactUs";
import Contracting from "./pages/Contracting";
import ErrorPage from "./pages/ErrorPage";
import HireWiingr from "./pages/HireWiingr";
import HomePage from "./pages/HomePage";
import Langgraph from "./pages/Langgraph";
import Nexus from "./pages/Nexus";
import NexusTermsOfService from "./pages/NexusTermsOfService";
import Post from "./pages/Post";
import PostForm from "./pages/PostForm";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Profile from "./pages/Profile";
import Rag from "./pages/Rag";
import StatementOfWork from "./pages/StatementOfWork";
import TermsOfService from "./pages/TermsOfService";
import WorkFlow from "./pages/Workflow";
import Loading from "./reusable-components/Loading";

function App() {
  const {
    REACT_APP_REPORT_PATH,
    REACT_APP_PORTFOLIO_SLUG,
    REACT_APP_HIRE_SLUG,
  } = process.env;
  const [isNotavailable, setIsNotAvailable] = React.useState(false);

  React.useEffect(() => {
    const availId = setTimeout(() => {
      setIsNotAvailable(true);
    }, 5000);

    return () => {
      clearTimeout(availId);
    };
  }, []);

  return (
    <AppProvider>
      <Routes>
        <Route exact path="/privacy" element={<PrivacyPolicy />} />
        <Route exact path="/terms" element={<TermsOfService />} />
        <Route exact path="/nexus/terms" element={<NexusTermsOfService />} />
        <Route exact path="/nexus" element={<Nexus />} />
        <Route
          exact
          path="/langchain/retrieval-augmented-generation"
          element={<Rag />}
        />
        <Route
          exact
          path="/langgraph/perplexity-chatbot"
          element={<Langgraph />}
        />
        <Route exact path="/ai-automation/:postid" element={<WorkFlow />} />
        <Route exact path="/nexus/blog" element={<Blog />} />
        <Route exact path="/nexus/blog/:postid" element={<Post />} />
        <Route exact path="/nexus/blog/post" element={<PostForm />} />
        <Route
          exact
          path="/nexus/csa/:client/:deliverable"
          element={<ClientServicesAgreement />}
        />
        <Route
          exact
          path="/nexus/sow/:client/:deliverable"
          element={<StatementOfWork />}
        />
        <Route exact path="/nexus/hire-us" element={<HireWiingr />} />
        <Route
          exact
          path={`/nexus/${REACT_APP_HIRE_SLUG}`}
          element={<Contracting />}
        />
        <Route exact path="/contact-us" element={<ContactUs />} />
        <Route
          exact
          path={`/portfolio/${REACT_APP_PORTFOLIO_SLUG}`}
          element={
            REACT_APP_PORTFOLIO_SLUG ? (
              <Profile />
            ) : (
              <Loading isNotavailable={isNotavailable} />
            )
          }
        />
        <Route
          exact
          path={`/${REACT_APP_REPORT_PATH}`}
          element={<AdminPage />}
        />
        <Route exact path="*" element={<ErrorPage />} />
        <Route exact path="/" element={<HomePage />} />
      </Routes>
    </AppProvider>
  );
}

export default App;
